import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileLocalMultiUploadRedesigned = _resolveComponent("FileLocalMultiUploadRedesigned")!
  const _component_CalculationForm = _resolveComponent("CalculationForm")!
  const _component_UploadingPopupStatus = _resolveComponent("UploadingPopupStatus")!
  const _component_CalculationPageWrapper = _resolveComponent("CalculationPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_CalculationPageWrapper, {
        key: 0,
        title: _ctx.title,
        type: _ctx.type,
        isShowLog: false,
        class: "uploading-excel"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CalculationForm, {
            disabled: _ctx.getUploadingDataStatus.isProgress,
            isLoading: _ctx.getIsFormLoading,
            onSubmit: _ctx.handleSubmitForm,
            class: "uploading-excel__form"
          }, {
            fields: _withCtx(() => [
              _createVNode(_component_FileLocalMultiUploadRedesigned, {
                modelValue: _ctx.file,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.file) = $event)),
                required: "",
                showEmpty: "",
                subtitle: _ctx.getFileSubtitle,
                validExtensions: [_ctx.FILE_PATH],
                disabled: _ctx.getUploadingDataStatus.isProgress || _ctx.isUploadingFile,
                isOnce: ""
              }, null, 8, ["modelValue", "subtitle", "validExtensions", "disabled"])
            ]),
            _: 1
          }, 8, ["disabled", "isLoading", "onSubmit"]),
          _createVNode(_component_UploadingPopupStatus, { info: _ctx.infoPopupDownloadStatus }, null, 8, ["info"])
        ]),
        _: 1
      }, 8, ["title", "type"]))
    : _createCommentVNode("", true)
}